import { h } from "preact";

import { classNames } from "../helpers.js";
import Icon from "./Icon.jsx";

export default function Tag(props) {
  function getCssState(value) {
    switch (value) {
      case "done":
        return "stateIcon--done";
      case "blocked":
        return "stateIcon--blocked";
      case "in progress":
        return "stateIcon--progress";
      case "ready":
        return "stateIcon--ready";
    }
  }

  const classes = classNames(
    "stateIcon",
    props.small && "stateIcon--small",
    getCssState(props.state),
    props.class
  );

  return (
    <span class={classes}>
      {props.state === "done" && (
        <Icon class="stateIcon__inner stateIcon__inner--done">
          check_circle
        </Icon>
      )}
      {props.state === "blocked" && (
        <Icon class="stateIcon__inner stateIcon__inner--blocked">block</Icon>
      )}
      {props.state === "in progress" && (
        <Icon class="stateIcon__inner stateIcon__inner--progress">pending</Icon>
      )}
      {props.state === "ready" && (
        <Icon class="stateIcon__inner stateIcon__inner--ready">circle</Icon>
      )}
    </span>
  );
}
